import { ref, onMounted } from "vue";
import { api } from "@app/data/api";
import { RestaurantSettingKey } from "@lemmonhq/types";
import { useToast } from "@app/vue/providers/Toast";
import { useLocalization } from "@lemmonhq/uikit";
import { useAuth } from "@app/vue/providers/Auth";

export function useAutoConfirmSetting() {
  const auth = useAuth();
  const toast = useToast();
  const { t } = useLocalization();

  const autoConfirmEnabled = ref(true);
  const autoConfirmLoading = ref(false);

  const load = async () => {
    try {
      const res = auth.user.value?.restaurant_settings || [];
      const setting = res.find(
        (s) => s.key === RestaurantSettingKey.RESERVATIONS_AUTO_CONFIRM,
      );
      autoConfirmEnabled.value =
        setting?.value === true || setting?.value === "true";
    } catch (e) {
      console.error("Failed to load auto-confirm setting", e);
    }
  };

  const handleToggleAutoConfirm = async () => {
    try {
      autoConfirmLoading.value = true;
      const newValue = !autoConfirmEnabled.value;
      await api.bulkUpdateSettings(
        {
          settings: [
            {
              key: RestaurantSettingKey.RESERVATIONS_AUTO_CONFIRM,
              value: String(newValue),
              value_type: "boolean",
            },
          ],
        },
        auth,
      );
      autoConfirmEnabled.value = newValue;
      toast.showToast(
        newValue
          ? t("reservations.auto_confirm.enabled_msg")
          : t("reservations.auto_confirm.disabled_msg"),
        { type: "success", autoHide: 3000 },
      );
    } catch (e) {
      console.error("Failed to toggle auto-confirm", e);
      toast.showToast(t("reservations.auto_confirm.failed"), {
        type: "error",
        autoHide: 3000,
      });
    } finally {
      autoConfirmLoading.value = false;
    }
  };

  onMounted(load);

  return { autoConfirmEnabled, autoConfirmLoading, handleToggleAutoConfirm };
}
